module.exports = __webpack_public_path__ + "static/media/Page04.acd596b7.png";